module.exports = __webpack_public_path__ + "static/img/zip.afacb7e0.svg";